import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, useRoute } from '@nuxtjs/composition-api';
import IconLink from './IconLink.vue';
import UserFolders from '~/components/hub/UserFolders.vue';
import UserProfileV2 from '~/components/hub/UserProfileV2.vue';
import UserTimeSaved from '~/components/hub/UserTimeSaved.vue';
import { resources, extras } from '~/data/navigation_links_hub_left';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmallNavLeft',
  setup(__props) {

const route = useRoute();

const sideNavClosed = ref(true);

const toggleSideNav = () => {
  sideNavClosed.value = !sideNavClosed.value;
};

watch(route, () => {
  sideNavClosed.value = true;
});

return { __sfc: true,route, sideNavClosed, toggleSideNav, IconLink, UserFolders, UserProfileV2, UserTimeSaved, resources, extras }
}

})